import _ from 'lodash';
const initialState ={
  result:[],
  sampling:[]
}
export default (state = initialState, action) => {
  let newsampling = _.cloneDeep(state.sampling)
  switch (action.type) {
   case "SAMPLING_DURATION_ACTION":
    return Object.assign({}, state, {
      duration: action.duration
    })    
    case "SAMPLING_TEMPLATE_ACTION":
    return Object.assign({}, state, {
      sampling: action.payload
    })
    case "SAMPLING_TEMPLATE_ADD":
        newsampling.push(action.prop)
      return Object.assign({}, state, {      
        sampling: newsampling
    })
    case "SAMPLING_TEMPLATE_EDIT":
      let x = _.findIndex(newsampling, {'templateTitle':action.title})  
      newsampling.splice(x, 1, action.newtemplate)
      return Object.assign({}, state, {      
        sampling: newsampling
    })   
    case "SAMPLING_MAPPED_LIST_ACTION":
      return Object.assign({}, state, {
        mappedData: action.mappedData
    }) 
    case "SAMPLING_TEMPLATE_DEFAULT":  
      return Object.assign({}, state, {
        default: action.default
    })
    case "SAMPLING_TEMPLATE_MAPPING":  
      return Object.assign({}, state, {
        mapstatus: action.mapstatus,
        mapmessage: action.mapmessage
    })
    case "SAMPLING_ERROR":  
      return Object.assign({}, state, {
        showerror: action.showerror,
        errmessage: action.errmessage,
    })
    case "SAMPLING_MODAL_CLOSE":  
      return Object.assign({}, state, {
        showerror: action.showerror
    })
  default:
    return state
  }
 }